webpackJsonp([1],{

/***/ "+7Px":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.node!=undefined)?_c('div',{attrs:{"id":"node-info-container"}},[_c('div',{staticClass:"node-iri"},[_vm._v(_vm._s(_vm.node.iri))]),_vm._v(" "),_c('div',{staticClass:"section-break"}),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.config.browser_property_prefs),function(browser_prop){return _c('div',_vm._l((_vm.nodeData.filter(function (datum) { return datum.property===browser_prop; })),function(nodeDatum){return _c('div',{staticClass:"node-data"},[_c('div',{staticClass:"prop-label"},[_vm._v(_vm._s(nodeDatum.property.replace(/_/g, " ")))]),_vm._v(" "),_vm._l((nodeDatum.values),function(val,index){return _c('div',{staticClass:"prop-val"},[_c('el-row',{staticClass:"value-row",attrs:{"type":"flex","justify":"space-between","align":"middle"}},[((typeof val.label !== 'undefined'))?_c('div',{staticClass:"pointer val-text",on:{"click":function($event){return _vm.treeNodeSelectedInternal({label:val.label,iri:val.value})}}},[_vm._v(_vm._s(val.label))]):_c('div',{staticClass:"val-text"},[_vm._v(_vm._s(val.value))]),_vm._v(" "),(_vm.settings.showAxiomAnnots===true && (typeof val.annotations !== 'undefined'))?_c('div',[_c('el-popover',{attrs:{"placement":"bottom","width":"400","trigger":"click","title":"annotations:"}},[_c('el-table',{attrs:{"data":val.annotations,"show-header":false}},[_c('el-table-column',{attrs:{"width":"200","property":"annotationProperty","label":"property"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","property":"annotationValue.value","label":"value"}})],1),_vm._v(" "),_c('i',{staticClass:"annot-icon el-icon-info",attrs:{"slot":"reference","type":"primary"},slot:"reference"})],1)],1):_vm._e()])],1)}),_vm._v(" "),_c('div',{staticClass:"section-break"}),_vm._v(" "),_c('hr')],2)}),0)}),_vm._v(" "),_vm._l((_vm.nodeData.filter(function (datum) { return (_vm.config.browser_property_prefs.indexOf(datum.property)===-1 && _vm.config.browser_property_exclusions.indexOf(datum.property)===-1); })),function(nodeDatum){return _c('div',{staticClass:"node-data"},[_c('div',{staticClass:"prop-label"},[_vm._v(_vm._s(nodeDatum.property.replace(/_/g, " ")))]),_vm._v(" "),_vm._l((nodeDatum.values),function(val){return _c('div',{staticClass:"prop-val"},[_c('el-row',{staticClass:"value-row",attrs:{"type":"flex","justify":"space-between"}},[((typeof val.label !== 'undefined'))?_c('div',{staticClass:"pointer val-text",on:{"click":function($event){return _vm.treeNodeSelectedInternal({label:val.label,iri:val.value})}}},[_vm._v(_vm._s(val.label))]):_c('div',{staticClass:"val-text"},[_vm._v(_vm._s(val.value))]),_vm._v(" "),(_vm.settings.showAxiomAnnots===true && (typeof val.annotations !== 'undefined'))?_c('div',[_c('el-popover',{attrs:{"placement":"bottom","width":"400","trigger":"click","title":"annotations:"}},[_c('el-table',{attrs:{"data":val.annotations,"show-header":false}},[_c('el-table-column',{attrs:{"width":"200","property":"annotationProperty","label":"property"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","property":"annotationValue.value","label":"value"}})],1),_vm._v(" "),_c('i',{staticClass:"annot-icon el-icon-info",attrs:{"slot":"reference","type":"primary"},slot:"reference"})],1)],1):_vm._e()])],1)}),_vm._v(" "),_c('div',{staticClass:"section-break"}),_vm._v(" "),_c('hr')],2)})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0+4p":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dataView.vue": "klBO",
	"./description.vue": "OZwJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0+4p";

/***/ }),

/***/ "3jhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3oT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('div',[_vm._v("navigation properties")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.treeProps,"border":true,"empty-text":"No Navigation Properties Set"}},[_c('el-table-column',{attrs:{"width":"200","property":"label","label":"label","class-name":'prop-label'}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"iri","label":"iri"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","property":"inv","label":"inverse","formatter":_vm.booleanRender}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){return _vm.treePropRemoveSelected(scope.$index)}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-edit",on:{"click":function($event){return _vm.treePropEditSelected(scope.$index)}}})]}}])}),_vm._v(" "),_c('template',{slot:"append"},[_c('i',{staticClass:"el-icon-plus add-prop-icon",on:{"click":function($event){_vm.addNavPropDialogVisible = true}}},[_vm._v(" Add Navigation Property")])])],2)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Add Navigation Property","visible":_vm.addNavPropDialogVisible,"width":"600","append-to-body":""},on:{"update:visible":function($event){_vm.addNavPropDialogVisible=$event}}},[_c('el-row',{staticClass:"tall-row",attrs:{"type":"flex","align":"middle"}},[_c('el-col',{staticClass:"label-column"},[_vm._v("label")]),_vm._v(" "),_c('el-col',{staticClass:"input-column"},[_c('el-input',{model:{value:(_vm.tempNavProp.label),callback:function ($$v) {_vm.$set(_vm.tempNavProp, "label", $$v)},expression:"tempNavProp.label"}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"tall-row",attrs:{"type":"flex","align":"middle"}},[_c('el-col',{staticClass:"label-column"},[_vm._v("iri")]),_vm._v(" "),_c('el-col',{staticClass:"input-column"},[_c('el-input',{model:{value:(_vm.tempNavProp.iri),callback:function ($$v) {_vm.$set(_vm.tempNavProp, "iri", $$v)},expression:"tempNavProp.iri"}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"tall-row",attrs:{"type":"flex","align":"middle"}},[_c('el-col',{staticClass:"label-column"},[_c('span',[_vm._v("inverse")]),_c('span',{staticClass:"highlight"},[_vm._v("*")])]),_vm._v(" "),_c('el-col',{staticClass:"input-column"},[_c('el-checkbox',{model:{value:(_vm.tempNavProp.inv),callback:function ($$v) {_vm.$set(_vm.tempNavProp, "inv", $$v)},expression:"tempNavProp.inv"}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"tall-row",attrs:{"type":"flex","align":"top"}},[_c('span',{staticClass:"highlight"},[_vm._v("*")]),_c('span',[_vm._v("unusual setting for navigation trees where parent to child relationship should be the inverse of specified property")])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.cancelUpdateNavProp()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.updateNavProp()}}},[_vm._v("Continue")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4aa1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5b80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiCarouselCardTree_vue__ = __webpack_require__("QBz7");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c618d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiCarouselCardTree_vue__ = __webpack_require__("ptOW");
function injectStyle (ssrContext) {
  __webpack_require__("4aa1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiCarouselCardTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c618d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiCarouselCardTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5eQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',{attrs:{"height":"60px"}},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","align":"middle"}},[_c('el-col',{attrs:{"span":12}},[_c('el-row',{attrs:{"type":"flex"}},[_c('img',{attrs:{"id":"logo","src":__webpack_require__("WUwu")}}),_vm._v(" "),_c('span',{attrs:{"id":"logo-text"}},[_vm._v(_vm._s(_vm.title))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12,"id":"header-tools"}},[_c('el-row',{attrs:{"type":"flex","align":"middle"}},[_c('el-col',{attrs:{"span":18}},[_c('el-row',{attrs:{"type":"flex","justify":"end"}},[_c('span',{attrs:{"id":"search-label"}},[_vm._v("search:")]),_vm._v(" "),_c('el-input',{staticClass:"search-input",attrs:{"placeholder":"enter search term ...","prefix-icon":"el-icon-search"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-row',{attrs:{"type":"flex","justify":"end","align":"middle"}},[_c('el-popover',{ref:"backpop",attrs:{"placement":"bottom","trigger":"hover","content":_vm.$store.getters.getNextNodeBackwardLabel}}),_vm._v(" "),_c('el-popover',{ref:"forwardpop",attrs:{"placement":"bottom","trigger":"hover","content":_vm.$store.getters.getNextNodeForwardLabel}}),_vm._v(" "),_c('el-button-group',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:backpop",arg:"backpop"}],staticClass:"history-button",attrs:{"type":"primary","size":"mini","icon":"el-icon-arrow-left","disabled":!_vm.$store.getters.getHasHistoryBackward},on:{"click":function($event){return _vm.$store.dispatch('historyBackward')}}}),_vm._v(" "),_c('el-button',{directives:[{name:"popover",rawName:"v-popover:forwardpop",arg:"forwardpop"}],staticClass:"history-button",attrs:{"type":"primary","size":"mini","icon":"el-icon-arrow-right","disabled":!_vm.$store.getters.getHasHistoryForward},on:{"click":function($event){return _vm.$store.dispatch('historyForward')}}})],1),_vm._v(" "),_c('i',{staticClass:"el-icon-setting",attrs:{"id":"settings-button"},on:{"click":_vm.showSettings}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('el-container',{attrs:{"id":"middle"}},[_c('el-main',[_c('browser',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"navWidth":_vm.navWidth}})],1)],1),_vm._v(" "),_c('el-footer',{attrs:{"height":"40px"}},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":14,"type":"flex"}},[_c('span',[_vm._v("Copyright © 2018 University of Washington Structural Informatics Group")])]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-row',{attrs:{"type":"flex","justify":"end"}},[_c('span',{attrs:{"id":"nav-width-label-area"}},[_vm._v("display:")]),_vm._v(" "),_c('div',{attrs:{"id":"nav-width-slider-area"}},[_c('el-slider',{attrs:{"max":24,"step":1},model:{value:(_vm.navWidth),callback:function ($$v) {_vm.navWidth=$$v},expression:"navWidth"}})],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4,"id":"footer-tools"}},[_c('el-row',{attrs:{"type":"flex","justify":"end","id":"bookmark-area","align":"middle"}},[(!_vm.isBookmarked)?_c('i',{staticClass:"el-icon-star-off",on:{"click":_vm.bookmarkAdd}}):_c('i',{staticClass:"el-icon-star-on",on:{"click":_vm.bookmarkRemove}}),_vm._v(" "),_c('span',{staticClass:"bookmark-label"},[_vm._v("bookmarks:")]),_vm._v(" "),_c('el-popover',{ref:"bookmarkPopover",attrs:{"placement":"top","width":"200","trigger":"hover"}},[(_vm.bookmarks.length>0)?_c('ul',_vm._l((_vm.bookmarks),function(item){return _c('li',{staticClass:"bookmark-text"},[_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){return _vm.bookmarkRemoveSelected(item)}}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.setSelectedNode(item)}}},[_vm._v(_vm._s(item.label))])])}),0):_c('span',[_vm._v("no bookmarks set")])]),_vm._v(" "),_c('el-button',{directives:[{name:"popover",rawName:"v-popover:bookmarkPopover",arg:"bookmarkPopover"}],attrs:{"size":"mini","type":"primary"}},[_vm._v("select")])],1)],1)],1)],1)],1),_vm._v(" "),_c('search-results-dialog',{attrs:{"visible":_vm.searchResultsDialogVisible,"fields":_vm.config.search.fields,"results":_vm.searchResults},on:{"node-selected":_vm.setSelectedNode,"search-close":function($event){_vm.searchResultsDialogVisible=false}}}),_vm._v(" "),_c('settings-dialog',{attrs:{"visible":_vm.settingsDialogVisible},on:{"settings-update":_vm.settingsUpdate,"settings-close":function($event){_vm.settingsDialogVisible=false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AHpp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"carouseltree-container"}},[_c('el-row',{staticClass:"full-height"},[_c('el-carousel',{attrs:{"trigger":"click","autoplay":false,"height":"100%","type":_vm.getStyle,"initial-index":_vm.selectedSlideIndex},on:{"change":_vm.changeActive}},_vm._l((_vm.properties),function(property,index){return _c('el-carousel-item',{key:property.key,staticClass:"tree-col",attrs:{"label":property.label}},[_c('div',{staticClass:"tree-area"},[(_vm.node!=undefined)?_c('biditree',{attrs:{"subject":_vm.subject,"property":property,"displaySubject":index===_vm.selectedSlideIndex},on:{"node-selected":_vm.treeNodeSelected}}):_vm._e()],1)])}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C9qN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GXiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navView_vue__ = __webpack_require__("XgpL");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0ce362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navView_vue__ = __webpack_require__("Yf1y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0ce362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GvjE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hfn6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navViews_bidiMultiTree__ = __webpack_require__("R+qH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['navWidth'],
  components: {},
  data: function data() {
    return {
      propertyIndex: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].init.propertyIndex,
      selectedDataView: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].initDataView
    };
  },

  created: function created() {
    this.loadNavViews();
    this.loadDataViews();
  },
  computed: {
    navView: function navView() {
      return this.$store.getters.getActiveNavView;
    },
    dataViews: function dataViews() {
      return this.$store.getters.getActiveDataViews;
    },
    contentWidth: function contentWidth() {
      return 24 - this.navWidth;
    },
    node: {
      get: function get() {
        return this.$store.getters.getNode;
      },
      set: function set(value) {
        this.$store.dispatch('setNodeWithHistory', value);
      }
    }

  },
  methods: {
    loadDataViews: function loadDataViews() {
      //var allViews = [];
      var vm = this;
      var context = __webpack_require__("0+4p");

      // load all data views discovered
      var allDataViews = [];
      context.keys().forEach(function (key) {
        var module = context(key);
        if (module.default.extends != undefined && module.default.extends.name === "DataView") {
          allDataViews.push({ name: module.default.name, view: module.default, isActive: true });
        }
      });

      // read config to get configured data views, include if also discoverable
      var confDataViewNames = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].dataViews;
      var dataViews = allDataViews.filter(function (view) {
        return confDataViewNames.includes(view.name);
      });
      vm.$store.commit("setAllDataViews", dataViews);

      // determine active dataViews from localStorage or config as appropriate
      var settingsFromLocalStorage = vm.$store.getters.settingsFromLocalStorage;
      if (settingsFromLocalStorage === true) {
        var activeDataViewsStore = vm.$store.getters.getActiveDataViews;
        var activeDataViewNames = activeDataViewsStore.map(function (view) {
          return view.name;
        });
        var currActiveDataViews = dataViews.filter(function (view) {
          return activeDataViewNames.includes(view.name);
        });
      } else {
        var currActiveDataViews = dataViews.filter(function (view) {
          return confDataViewNames.includes(view.name);
        });
      }

      vm.$store.commit("setActiveDataViews", currActiveDataViews);
    },
    loadNavViews: function loadNavViews() {
      var vm = this;
      var context = __webpack_require__("gagE");

      // load all nav views discovered
      var allNavViews = [];
      context.keys().forEach(function (key) {
        var module = context(key);
        if (module.default.extends != undefined && module.default.extends.name === "NavView") {
          allNavViews.push({ name: module.default.name, view: module.default, isActive: true });
          //vm.dataViews.push({name:module.default.name,view:module.default,isActive:true});
        }
      });

      // read config to get configured nav views, include if also discoverable
      var confNavViewNames = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].navViews;
      var navViews = allNavViews.filter(function (view) {
        return confNavViewNames.includes(view.name);
      });

      vm.$store.commit("setAllNavViews", navViews);

      // determine active dataViews from localStorage or config as appropriate
      var settingsFromLocalStorage = vm.$store.getters.settingsFromLocalStorage;
      if (settingsFromLocalStorage === true) {
        var activeNavViewStore = vm.$store.getters.getActiveNavView;
        var currActiveNavView = navViews.find(function (view) {
          return view.name === activeNavViewStore.name;
        });
      } else {
        var currActiveNavView = navViews.find(function (view) {
          return view.name === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].initNavView;
        });
      }
      vm.$store.commit("setActiveNavView", currActiveNavView);
    },
    nodeSelected: function nodeSelected(node) {
      this.node = node;
      var tabContent = document.getElementById('tab-content');
      //temp tabContent.scrollTop = 0;
    },
    updateNodeData: function updateNodeData(results) {
      var resObj = results;
      var bindings = resObj.results.bindings;
      var propVals = [];

      var lastProp = null;
      var currValArray = null;
      for (var count = 0; count < bindings.length; count++) {
        var binding = bindings[count];
        var currProp = binding.property.value;

        if (lastProp === null || currProp !== lastProp) {
          // new property found
          lastProp = currProp;
          currValArray = [];
          propVals.push({ property: lastProp, values: currValArray });
        }
        var val = {};
        val['value'] = binding.value.value;
        if (typeof binding.label !== "undefined") {
          val['label'] = binding.label.value;
        }
        currValArray.push(val);
      }

      this.nodeData = propVals;
    },
    handleErrors: function handleErrors(errors) {
      //TODO: need to do something better with error handling
      alert("browser errors: " + errors);
    }
  }
});

/***/ }),

/***/ "IVpW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L7oS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queries; });
var queries = {
  iri_query: function iri_query(search_iri) {
    return "\n    PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n    PREFIX cpo: <http://purl.org/sig/ont/cpo/>\n    SELECT ?label\n    WHERE\n    {\n      #<" + search_iri + "> rdfs:label ?label.\n      BIND (<" + search_iri + "> AS ?iri)\n      OPTIONAL {?iri rdfs:label ?label}.\n      OPTIONAL {?actualIRI cpo:altIRI ?iri. ?actualIRI rdfs:label ?label}\n    }\n    ";
  },
  search_query: function search_query(search_term) {
    return "\n    PREFIX text: <http://jena.apache.org/text#>\n    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n    PREFIX owl: <http://www.w3.org/2002/07/owl#>\n    PREFIX cpo: <http://purl.org/sig/ont/cpo/>\n    PREFIX ocdm: <http://purl.org/sig/ont/ocdm/>\n    SELECT distinct ?subject (?literal AS ?term) ?label ?species\n    WHERE {\n      VALUES ?property {cpo:preferred_name cpo:synonym cpo:non-English_equivalent rdfs:label}.\n      (?subject ?score ?literal) text:query (?property '" + search_term + "').\n      ?subject rdfs:label ?label.\n      OPTIONAL\n      {\n        BIND (\"human\" AS ?species).\n        Values ?human_roots {ocdm:ocdm0000001}.\n        ?subject rdfs:subClassOf* ?human_roots.\n      }\n      OPTIONAL\n      {\n        BIND (\"mouse\" AS ?species).\n        Values ?mouse_roots {ocdm:ocdm0000002}.\n        ?subject rdfs:subClassOf* ?mouse_roots.\n      }\n      OPTIONAL\n      {\n        BIND (\"zebrafish\" AS ?species).\n        Values ?zebrafish_roots {ocdm:ocdm0000003}.\n        ?subject rdfs:subClassOf* ?zebrafish_roots.\n      }\n      FILTER(bound(?species)).\n    }\n    ORDER BY DESC(?score)\n    ";
  },
  all_properties_query: function all_properties_query(iri) {
    return "\n    PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n\t  PREFIX owl: <http://www.w3.org/2002/07/owl#>\n    PREFIX cpo: <http://purl.org/sig/ont/cpo/>\n    SELECT distinct ?property ?value ?label ?annotProperty ?annotValue\n    WHERE\n    {\n      BIND (<" + iri + "> AS ?subject).\n  \t  #?subject rdf:type owl:NamedIndividual.\n\n      ?subject ?property ?value.\n      FILTER(STRSTARTS(STR(?property), \"http://purl.org/sig/ont/cpo/\")).\n\n      # get value label if it has one\n      OPTIONAL{?value rdfs:label ?label}\n\n      # ignore blank nodes since we have puns\n      FILTER (!isBlank(?value)).\n\n      # get axiom annotations if present\n      OPTIONAL {\n        ?subproperty rdfs:subPropertyOf ?property.\n        ?axiom owl:annotatedSource ?subject.\n        ?axiom owl:annotatedProperty ?subproperty.\n        ?axiom owl:annotatedTarget ?value.\n        ?axiom ?annotProperty ?annotValue.\n        FILTER(STRSTARTS(STR(?annotProperty), \"http://purl.org/sig/ont/cpo/\")).\n      }\n    }\n    ORDER BY (lcase(str(?property)))\n    ";
  },
  axiom_annotations_query: function axiom_annotations_query(subject, property, object) {
    return "\n    PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n\t  PREFIX owl: <http://www.w3.org/2002/07/owl#>\n    PREFIX fma: <http://purl.org/sig/ont/fma/>\n    SELECT distinct ?rel ?annot\n    WHERE\n    {\n      # get axiom annotations if present\n      OPTIONAL {\n        ?axiom owl:annotatedSource <" + subject + ">.\n        ?axiom owl:annotatedProperty <" + property + ">.\n        ?axiom owl:annotatedTarget <" + object + ">.\n        ?axiom ?rel ?annot.\n        FILTER(STRSTARTS(STR(?rel), \"http://purl.org/sig/ont/fma/\")).\n      }\n    }\n    ORDER BY (lcase(str(?rel)))\n    ";
  },
  directional_relation_query: function directional_relation_query(iri, relationship, inverse) {
    if (!inverse) {
      return "\n      PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n      SELECT distinct ?related ?label (!bound(?next) as ?terminal)\n      WHERE\n      {\n        <" + iri + "> <" + relationship + "> ?related .\n        ?related  rdfs:label ?label.\n        OPTIONAL{?related <" + relationship + "> ?next.}\n      }\n      ";
    } else {
      return "\n      PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n      SELECT distinct ?related ?label (!bound(?next) as ?terminal)\n      WHERE\n      {\n        ?related <" + relationship + "> <" + iri + "> .\n        ?related  rdfs:label ?label.\n        OPTIONAL{?next <" + relationship + "> ?related.}\n      }\n      ";
    }
  },

  // The queries beyond this point were used to demonstrate "smart" queries
  related_non_lateralized_query: function related_non_lateralized_query(iri) {
    return "\n    PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n    PREFIX owl: <http://www.w3.org/2002/07/owl#>\n    PREFIX cpo: <http://purl.org/sig/ont/cpo/>\n    SELECT distinct ?result ?resultLabel\n    WHERE{\n      BIND (<" + iri + ">  AS ?subject).\n\n      # will bind if concept is lateralized\n      ?subject cpo:part_of* ?sup.\n      ?sup rdfs:label ?label.\n      FILTER(STRSTARTS(STR(?label), \"Right\")||STRSTARTS(STR(?label), \"Left\")).\n\n      ?subject rdfs:subClassOf ?result.\n      ?result rdfs:label ?resultLabel.\n    }\n    ";
  },
  related_parts_query: function related_parts_query(iri) {
    return "\n    PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n    PREFIX owl: <http://www.w3.org/2002/07/owl#>\n    PREFIX cpo: <http://purl.org/sig/ont/cpo/>\n    SELECT distinct ?result ?resultLabel\n    WHERE{\n      BIND (<" + iri + "> AS ?subject).\n\n      ?subject cpo:part{1,2} ?candidate.\n\n      {\n      \tbind (?candidate as ?result).\n        ?result rdfs:label ?resultLabel.\n      }\n      union\n      {\n        ?candidate cpo:part_of* ?sup.\n        ?sup rdfs:label ?label.\n        FILTER(STRSTARTS(STR(?label), \"Right\")||STRSTARTS(STR(?label), \"Left\")).\n        ?candidate rdfs:subClassOf ?result.\n        ?result rdfs:label ?resultLabel.\n      }\n    }\n    ";
  },
  related_development_query: function related_development_query(iri) {
    return "\n    PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n    PREFIX owl: <http://www.w3.org/2002/07/owl#>\n    PREFIX cpo: <http://purl.org/sig/ont/cpo/>\n    SELECT distinct ?result ?resultLabel\n    WHERE{\n      BIND (<" + iri + ">  AS ?subject).\n\n      ?subject cpo:matures_from+/^rdfs:subClassOf* ?candidate.\n\n      {\n        bind (?candidate as ?result).\n        ?result rdfs:label ?resultLabel.\n      }\n      union\n      {\n        ?candidate cpo:part_of* ?sup.\n        ?sup rdfs:label ?label.\n        FILTER(STRSTARTS(STR(?label), \"Right\")||STRSTARTS(STR(?label), \"Left\")).\n        ?candidate rdfs:subClassOf ?result.\n        ?result rdfs:label ?resultLabel.\n      }\n    }\n    ";
  },
  related_dev_part_query: function related_dev_part_query(iri) {
    return "\n    PREFIX rdfs:<http://www.w3.org/2000/01/rdf-schema#>\n    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n    PREFIX owl: <http://www.w3.org/2002/07/owl#>\n    PREFIX cpo: <http://purl.org/sig/ont/cpo/>\n    SELECT distinct ?result ?resultLabel\n    WHERE{\n      BIND (<" + iri + ">  AS ?subject).\n\n      ?subject rdfs:subClassOf{,2}/cpo:part+/^rdfs:subClassOf{,2} ?candidate.\n      ?subject cpo:has_embryonic_day ?subjDay.\n      ?candidate cpo:has_embryonic_day ?candDay.\n\n      FILTER(?subjDay=?candDay).\n\n      {\n        bind (?candidate as ?result).\n        ?result rdfs:label ?resultLabel.\n      }\n      union\n      {\n        ?candidate cpo:part_of* ?sup.\n        ?sup rdfs:label ?label.\n        FILTER(STRSTARTS(STR(?label), \"Right\")||STRSTARTS(STR(?label), \"Left\")).\n        ?candidate rdfs:subClassOf ?result.\n        ?result rdfs:label ?resultLabel.\n      }\n    }\n    ";
  }
};



/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a14d3e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("5eQN");
function injectStyle (ssrContext) {
  __webpack_require__("O0q0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a14d3e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mema":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_store__ = __webpack_require__("ZiWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







//import Vuex from 'vuex'
//Vue.use(Vuex)

//import Vuetify from 'vuetify'
//Vue.use(Vuetify)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a });

//import VueResource from 'vue-resource'
//Vue.use(VueResource);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// global registration of View plugins
var allDataViews = loadDataViews();
var allNavViews = loadNavViews();

// global error handler
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.errorHandler = function (err, vm, info) {
  alert("err: " + err + ", vm: " + vm + ", info:" + info);
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  data: {
    allDataViews: allDataViews,
    allNavViews: allNavViews
  },
  store: __WEBPACK_IMPORTED_MODULE_6__state_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },

  beforeCreate: function beforeCreate() {
    this.$store.commit('initializeSettings');
  }
});

function loadDataViews() {
  var context = __webpack_require__("0+4p");
  //console.log("dataview context = "+JSON.stringify(context.keys()));

  // load all data views discovered
  var allDataViews = [];
  context.keys().forEach(function (key) {
    var module = context(key);
    if (module.default.extends != undefined && module.default.extends.name === "DataView") {
      var dataViewComp = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(module.default.name, module.default);
      allDataViews.push({ name: module.default.name, view: dataViewComp, isActive: true });
      //vm.dataViews.push({name:module.default.name,view:module.default,isActive:true});
    }
  });

  return allDataViews;
}

function loadNavViews() {
  var context = __webpack_require__("gagE");
  //console.log("dataview context = "+JSON.stringify(context.keys()));

  // load all data views discovered
  var allNavViews = [];
  context.keys().forEach(function (key) {
    var module = context(key);
    if (module.default.extends != undefined && module.default.extends.name === "NavView") {
      var navViewComp = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(module.default.name, module.default);
      allNavViews.push({ name: module.default.name, view: navViewComp, isActive: true });
      //vm.dataViews.push({name:module.default.name,view:module.default,isActive:true});
    }
  });

  return allNavViews;
}

/***/ }),

/***/ "NJPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchResultsDialog_vue__ = __webpack_require__("mjtd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5a0837a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchResultsDialog_vue__ = __webpack_require__("a/Kl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchResultsDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5a0837a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchResultsDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O0q0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OZwJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_description_vue__ = __webpack_require__("s5U/");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bcd6f97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_description_vue__ = __webpack_require__("+7Px");
function injectStyle (ssrContext) {
  __webpack_require__("RNbq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_description_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bcd6f97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_description_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Omah":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




//import VueResource from 'vue-resource';
//Vue.use(VueResource);
var state = {
  'endpoint': __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].sparql_endpoint.url,
  'queries': __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].queries
};

var getters = {
  'getEndpoint': function getEndpoint(state) {
    return state.endpoint;
  },
  'getQueries': function getQueries(state) {
    return state.queries;
  }
};

var mutations = {};

var actions = {
  /*
  query: function (context,queryInfo) {
  	var queryString = queryInfo.query;
  	var successCallback = queryInfo.successCallback;
  	var errorCallback = queryInfo.errorCallback;
  	//queryString,successCallback,errorCallback
  	var promise = context.sendquery(queryString);
  	promise.then((results) => {
  		successCallback(results);
  	}).catch((errors) => {
  		errorCallback(errors.statusText);
  	});
  },
  */
  query: function query(context, queryObject) //queryString, resulttype, success_function, error_function)
  {
    var queryString = queryObject.query;
    var resultType = queryObject.resultType;
    if (resultType == null) {
      resultType = "json";
    }
    //var success_function = queryObject.success_function;
    //var error_function = queryObject.error_function;
    var accept, datatype;
    if (resultType === "xml") {
      accept = "application/rdf+xml; charset=utf-8";
      //datatype = "xml";
    } else if (resultType === "json") {
      accept = "application/sparql-results+json; charset=utf-8";
      //datatype = "json";
    }
    /*
    else if(resultType === "json-ld"){
    	accept = "application/ld+json"
    }*/

    // Note, we are not currently using the "datatype" field
    var options = {
      params: { query: queryString },
      headers: { Accept: accept }
      //responseType: 'json'
    };

    var queryID = _.uniqueId();
    var queryUrl = this.getters.getEndpoint; //+"?query="+encodeURIComponent(queryString);
    //var http = this.getters.getHttp();
    context.commit('setQueryStarted', queryID, { root: true });
    var remotePromise = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(queryUrl, options).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
    context.commit('setQueryFinished', queryID, { root: true });
    return remotePromise;
    /*
    Vue.http.get(queryUrl,options).then(
    response => success_function, response => error_function
    );
    */
  }
};

var module = {
  namespaced: false,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),

/***/ "PPU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settingsDialog_vue__ = __webpack_require__("rGej");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4b5dc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settingsDialog_vue__ = __webpack_require__("TX9r");
function injectStyle (ssrContext) {
  __webpack_require__("GvjE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settingsDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4b5dc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settingsDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QBz7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navViews_navView_vue__ = __webpack_require__("GXiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navViews_bidiTree__ = __webpack_require__("fk9h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_settingsViews_bidiTreeSettingsView__ = __webpack_require__("q+cR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['node'],
  components: {
    biditree: __WEBPACK_IMPORTED_MODULE_2__components_navViews_bidiTree__["default"]
  },
  name: 'BidiCarouselCardTree',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_navViews_navView_vue__["default"],
  data: function data() {
    return {
      settingsDialogVisible: false,

      selectedSlideIndex: 0,
      initSettings: {
        treeProps: _.cloneDeep(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].navProperties),
        isCardStyle: true
      },
      settingsView: __WEBPACK_IMPORTED_MODULE_3__components_settingsViews_bidiTreeSettingsView__["a" /* default */]
    };
  },

  watch: {
    properties: {
      handler: function handler(newVal) {
        this.assignKeys();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.assignKeys();
  },
  computed: {
    subject: function subject() {
      if (this.node == undefined) {
        return null;
      }
      return { data: { iri: this.node.iri }, label: this.node.label };
    },
    getStyle: function getStyle() {
      var style = this.settings.isCardStyle ? 'card' : '';
      return style;
    },
    properties: function properties() {
      if (this.settings == undefined) {
        return [];
      }
      return this.settings.treeProps;
    }
  },
  methods: {
    treeNodeSelected: function treeNodeSelected(nodeinfo) {
      this.$emit('node-selected', nodeinfo);
      //this.refresh(item);
    },
    assignKey: function assignKey(propIndex) {
      var prop = this.properties[propIndex];
      prop.key = prop.label + '_' + Date.now();
    },
    assignKeys: function assignKeys() {
      this.properties.forEach(function (prop) {
        prop.key = prop.label + '_' + Date.now();
      });
    },
    changeActive: function changeActive(index) {
      this.selectedSlideIndex = index;
      //alert("new active slide index = "+index);
    }
  }
});

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries__ = __webpack_require__("L7oS");


var _config;



var config = (_config = {
  // info needed at start-up
  title: 'OCDM Browser',
  init: {
    node: { label: "Mandible", iri: "http://purl.org/sig/ont/fma/fma52748" }
  },

  // trees to include
  navProperties: [{ iri: 'http://www.w3.org/2000/01/rdf-schema#subClassOf', label: 'subclass of', inv: true }, { iri: 'http://purl.org/sig/ont/cpo/part', label: 'part', inv: false }],

  navViews: ['BidiCarouselCardTree', 'BidiCarouselTree', 'BidiMultiTree'],
  initNavView: 'BidiCarouselTree',
  dataViews: ['Description', 'Images', 'Scenes'],
  initDataView: 'Description',

  // info to show in content area
  browser_property_prefs: ["preferred_name", "synonym", "non-English_equivalent", "definition", "mapsTo"],
  browser_property_exclusions: ["part", "part_of", "verified", "verified_by"],

  // server communication
  // Use si.washington.edu for production
  sparql_endpoint: { url: "http://synapse.si.washington.edu:3030/ocdm/sparql" },
  //  sparql_endpoint: {url:"http://sparqldev.si.washington.edu:3030/ocdm/sparql"},
  //  sparql_endpoint: {url:"http://localhost:3030/ocdm/sparql"},
  search: { query: __WEBPACK_IMPORTED_MODULE_1__queries__["a" /* queries */].search_query, fields: ['term', 'species'] }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, 'search', { query: __WEBPACK_IMPORTED_MODULE_1__queries__["a" /* queries */].search_query, fields: ['term', 'species'] }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, 'iri_search', { query: __WEBPACK_IMPORTED_MODULE_1__queries__["a" /* queries */].iri_query }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, 'queries', __WEBPACK_IMPORTED_MODULE_1__queries__["a" /* queries */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_config, 'navWidth', 16), _config);



/***/ }),

/***/ "R+qH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiMultiTree_vue__ = __webpack_require__("ohIK");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb56f5f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiMultiTree_vue__ = __webpack_require__("SiaT");
function injectStyle (ssrContext) {
  __webpack_require__("Mema")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiMultiTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb56f5f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiMultiTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RJgE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['property', 'subject', 'displaySubject'],
  data: function data() {
    return {
      'loading': false,
      'subjectNode': { 'level': 0, 'label': this.subject.label, 'isleaf': false, 'expanded': true, 'data': this.subject.data },
      'upNodesAsList': [],
      'downNodesAsList': [],
      'lastExpanded': null
    };
  },

  watch: {
    property: {
      handler: function handler(newVal) {
        console.log("property change in biditree");
        this.refresh(this.subjectNode);
      },
      deep: true
    },
    subject: function subject(val) {
      this.subjectNode = { 'level': 0, 'label': val.label, 'isleaf': false, 'expanded': true, 'data': val.data };
      this.refresh(this.subjectNode);
      //this.nodeSelected(val);
    }
  },
  created: function created() {
    //this.subjectNode = {'level':0,'label':this.subject.label,'isleaf':false,'expanded':true,'data':this.subject.data};
    this.refresh(this.subjectNode);
  },
  methods: {
    refresh: function refresh(subjectNode) {
      //this.subjectNode = subjectNode;
      this.subjectNode = { 'level': 0, 'label': subjectNode.label, 'isleaf': false, 'expanded': true, 'data': subjectNode.data };
      //{'level':0,'label':this.subject.label,'isleaf':false,'expanded':true,'data':this.subject.data};
      this.upNodesAsList = [];
      this.downNodesAsList = [];
      this.loadNode(this.subjectNode, "up", this.addChildren);
      this.loadNode(this.subjectNode, "down", this.addChildren);
    },
    addChildren: function addChildren(node, direction, children) {
      //console.log("node:"+node.label+", dir:"+direction+", children"+children );

      if (direction === "up") {
        // find node in list
        var nodeIndex = this.upNodesAsList.indexOf(node);
        for (var childInd = 0; childInd < children.length; childInd++) {
          var currChild = children[childInd];
          if (nodeIndex === -1) {
            nodeIndex = 0;
          }
          this.upNodesAsList.splice(nodeIndex, 0, { 'level': node.level + 1, 'label': currChild.label, 'isleaf': currChild.leaf,
            'expanded': false, 'data': { 'iri': currChild.iri }, 'loaded': false });
        }
      } else {
        // find node in list
        var nodeIndex = this.downNodesAsList.indexOf(node);
        for (var childInd = 0; childInd < children.length; childInd++) {
          var currChild = children[childInd];
          this.downNodesAsList.splice(nodeIndex + 1, 0, { 'level': node.level + 1, 'label': currChild.label, 'isleaf': currChild.leaf,
            'expanded': false, 'data': { 'iri': currChild.iri }, 'loaded': false });
        }
      }
      node.loaded = true;
    },
    loadNode: function loadNode(node, direction, resolve) {

      var queries = this.$store.getters.getQueries;
      var inverse = direction === "up" ? true : false;

      // swap this if inv is set in property
      if (this.property.inv) {
        inverse = !inverse;
      }

      var subordinateQuery = queries.directional_relation_query(node.data.iri, this.property.iri, inverse);

      function success(results) {
        // form results here

        var resObj = results; //JSON.parse(results);
        var bindings = resObj.results.bindings;
        var children = [];
        for (var count = 0; count < bindings.length; count++) {
          var binding = bindings[count];
          var child = { 'iri': binding.related.value, 'label': binding.label.value, 'leaf': binding.terminal.value === 'true' };
          children.push(child);
        }
        resolve(node, direction, children);
      }

      this.query(subordinateQuery, success, this.displayErrors);
    },
    query: function query(queryString, successCallback, errorCallback) {
      //var queryString = 'SELECT * WHERE {?a ?b ?c} limit 10';
      var promise = this.$store.dispatch('query', { query: queryString });
      promise.then(function (results) {
        // successMessage is whatever we passed in the resolve(...) function above.
        // It doesn't have to be a string, but if it is only a succeed message, it probably will be.

        //console.log(results)
        successCallback(results);
      }).catch(function (errors) {
        //console.log(errors);
        errorCallback(errors.statusText);
      });
    },
    //getChildren: function() YOU ARE HERE!
    displayResults: function displayResults(results) {
      alert("results: " + results);
    },
    displayErrors: function displayErrors(errors) {
      //alert("errors: "+errors);
      //console.log("biditree errors = "+errors);
    },

    nodeID: function nodeID(node) {
      var id = node.level === 0 ? 'subject' : 'node';
      return id;
    },
    nodeInfo: function nodeInfo(node, dir) {
      // compute css class for node li
      var nodeInfo;
      if (node.isleaf) {
        var nodestyle = "leaf";
        var nodeicon = "el-icon-remove-outline hidden";
        nodeInfo = { "style": nodestyle, "icon": nodeicon };
      } else if (!node.expanded) {
        var nodestyle = "unexpanded";
        var nodeicon = "el-icon-arrow-right";
        var iconevent = "expand";
        nodeInfo = { "style": nodestyle, "icon": nodeicon, "event": iconevent };
      } else if (dir === "up") {
        var nodestyle = "upexpanded";
        var nodeicon = "el-icon-arrow-up";
        nodeInfo = { "style": nodestyle, "icon": nodeicon };
      } else if (dir === "down") {
        var nodestyle = "downexpanded";
        var nodeicon = "el-icon-arrow-down";
        var iconevent = "test()";
        nodeInfo = { "style": nodestyle, "icon": nodeicon, "event": iconevent };
      } else {
        // this should only happen for subject node
        var nodestyle = "subject";
        nodeInfo = { "style": nodestyle };
      }
      return nodeInfo;
    },
    nodeSelected: function nodeSelected(item) {
      this.$emit('node-selected', { iri: item.data.iri, label: item.label });
      //this.refresh(item);
    },
    treeIconClicked: function treeIconClicked(node) {
      this.lastExpanded = node;

      /*
      // if it is expanded and is not the subject, then collapse
      if(node.expanded && node.level!==0){
        this.collapse(node);
      }
      */
      if (node.expanded) {
        this.collapse(node);
      }
      // if node is not expanded, and is not a leaf, expand it
      else if (!node.expanded && !node.isleaf) {
          if (!node.loaded) {
            var isUp = this.upNodesAsList.indexOf(node) === -1 ? false : true;
            var dir = isUp ? 'up' : 'down';
            this.loadNode(node, dir, this.addChildren);
          }
          this.expand(node);
        }
    },
    expand: function expand(node) {
      node.expanded = true;
    },
    collapse: function collapse(node) {
      node.expanded = false;
    },
    getParent: function getParent(node, dir) {
      // get proper list
      var nodesAsList = dir === "up" ? this.upNodesAsList : this.downNodesAsList;

      // get index of current node in list
      var nodeIndex = nodesAsList.indexOf(node);

      // get the level of the current node
      var nodeLevel = node.level;

      // get the direction of the current node
      var nodeDir = dir;

      if (nodeDir === 'up') {
        for (var currIndex = nodeIndex + 1; currIndex < nodesAsList.length; currIndex++) {
          var currNode = nodesAsList[currIndex];
          if (currNode.level < nodeLevel) {
            return currNode;
          }
        }
        // if we didn't find an "up-tree" node with a lesser level, then
        // this node is a direct child of the subject node
        return this.subjectNode;
      } else if (nodeDir === 'down') {
        for (var currIndex = nodeIndex - 1; currIndex >= 0; currIndex--) {
          var currNode = nodesAsList[currIndex];
          if (currNode.level < nodeLevel) {
            return currNode;
          }
        }
        // if we didn't find an "up-tree" node with a lesser level, then
        // this node is a direct child of the subject node
        return this.subjectNode;
      }

      alert("should not have made it here: " + node.label);
    },
    isVisible: function isVisible(node, dir) {
      // if this node is the subject, it should be visible
      if (node === this.subjectNode /*typeof dir === 'undefined'*/) {
          return true;
        }

      // if parent is not expanded, node is not visible
      var parentNode = this.getParent(node, dir);
      if (!parentNode.expanded) {
        return false;
      }

      // if we made it here, this is not the subject node and its parent is expanded
      // however, there could still be a collapsed node further up the tree
      if (this.isVisible(parentNode, dir)) {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),

/***/ "RNbq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SiaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"multitree-container"}},[_c('el-row',{attrs:{"id":"full-height"}},_vm._l((_vm.treeProps),function(property,index){return _c('el-col',{key:index,staticClass:"tree-col",attrs:{"span":_vm.treeColWidth}},[_c('div',{staticClass:"tree-prop-area"},[_c('span',{staticClass:"property-input-label"},[_vm._v("property: "+_vm._s(property.label))])]),_vm._v(" "),_c('div',{staticClass:"tree-area"},[(_vm.node!=undefined)?_c('biditree',{attrs:{"subject":_vm.subject,"property":property,"display-subject":true},on:{"node-selected":_vm.treeNodeSelected}}):_vm._e()],1)])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TX9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"Settings","visible":_vm.visible},on:{"close":_vm.close}},[_c('span',{staticClass:"settings-header"},[_vm._v("General Settings")]),_vm._v(" "),_c('div',{staticClass:"settings-area"},[_c('el-row',{staticClass:"option-row"},[_c('el-col',{staticClass:"settings-label",attrs:{"span":6}},[_c('span',[_vm._v("active navigation view:")])]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('el-select',{attrs:{"placeholder":"Select","value-key":"name"},model:{value:(_vm.tempActiveNavView),callback:function ($$v) {_vm.tempActiveNavView=$$v},expression:"tempActiveNavView"}},_vm._l((_vm.$store.getters.getAllNavViews),function(view){return _c('el-option',{key:view.name,attrs:{"label":view.name,"value":view}})}),1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"option-row"},[_c('el-col',{staticClass:"settings-label",attrs:{"span":6}},[_c('span',[_vm._v("active data views:")])]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('el-select',{attrs:{"multiple":"","placeholder":"Select","value-key":"name"},model:{value:(_vm.tempActiveDataViews),callback:function ($$v) {_vm.tempActiveDataViews=$$v},expression:"tempActiveDataViews"}},_vm._l((_vm.$store.getters.getAllDataViews),function(view){return _c('el-option',{key:view.name,attrs:{"label":view.name,"value":view}})}),1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.clearStoredSettings}},[_vm._v("clear saved settings")]),_vm._v(" "),_c('span',{staticClass:"warning"},[_vm._v("* Warning, this will reset selected concept as well")])],1)],1),_vm._v(" "),_c('span',{staticClass:"settings-header"},[_vm._v("Navigation View Settings")]),_vm._v(" "),_c('div',{staticClass:"settings-area"},[(_vm.tempActiveNavView.view.data().settingsView !== undefined)?_c('div',[_c('span',{staticClass:"view-name"},[_vm._v(_vm._s(_vm.tempActiveNavView.name)+" navigation view settings:")]),_vm._v(" "),_c(_vm.tempActiveNavView.view.data().settingsView,{ref:_vm.tempActiveNavView.view.data().settingsView.name,tag:"component",attrs:{"view":_vm.tempActiveNavView}})],1):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"settings-header"},[_vm._v("Data View Settings")]),_vm._v(" "),_c('div',{staticClass:"settings-area"},_vm._l((_vm.tempActiveDataViews),function(dataView){return (dataView.view.data().settingsView !== undefined)?_c('div',[_c('span',{staticClass:"view-name"},[_vm._v(_vm._s(dataView.name)+" data view settings:")]),_vm._v(" "),_c(dataView.view.data().settingsView,{ref:dataView.view.data().settingsView.name,refInFor:true,tag:"component",attrs:{"view":dataView}})],1):_vm._e()}),0),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.update}},[_vm._v("Update")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uh1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_settingsViews_settingsView_vue__ = __webpack_require__("XreW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BidiTreeSettingsView",
  extends: __WEBPACK_IMPORTED_MODULE_0__components_settingsViews_settingsView_vue__["a" /* default */],
  data: function data() {
    return {
      addNavPropDialogVisible: false,
      tempNavProp: null,
      editIndex: -1
    };
  },

  computed: {
    treeProps: {
      get: function get() {
        //console.log(this.settings['treeProps']);
        return this.settings['treeProps'];
      },
      set: function set(val) {
        //var newSettings = _.cloneDeep(this.settings);
        //var newSettings = this.settings;
        //newSettings['showAxiomAnnots']=val;
        //this.settings = newSettings;
        //        this.settings['treeProps']=val;
        this.$set(this.settings['treeProps'], this.editIndex, this.tempNavProp);
        //this.settingsUpdate();
      }
    }
  },
  /*
  watch: {
    settings: {
      handler: function(newVal){
        console.log('newSettings = '+JSON.stringify(newVal));
      },
      deep:true,
    },
    treeProps: {
      handler: function(newVal){
        console.log('treeProps = '+JSON.stringify(newVal));
        //this.$set(this.settings['treeProps'],this.editIndex,this.tempNavProp);
      },
      deep:true,
    }
  },
  */
  created: function created() {
    this.resetTempNavProp();
  },
  methods: {
    booleanRender: function booleanRender(row, column, cellValue) {
      return String(cellValue);
    },
    treePropRemoveSelected: function treePropRemoveSelected(index) {
      this.treeProps.splice(index, 1);
      //var newTreeProps = this.treeProps.filter(item => item !== treeProp);
      //this.treeProps = newTreeProps;
    },
    treePropEditSelected: function treePropEditSelected(index, treeProp) {
      this.editIndex = index;
      this.tempNavProp = this.treeProps[index];
      this.addNavPropDialogVisible = true;
      //TODO: not yet implemented
    },
    updateNavProp: function updateNavProp() {
      if (this.editIndex === -1) {
        this.treeProps.push(this.tempNavProp);
      } else {
        //this.treeProps.splice(this.editIndex, 1, this.tempNavProp);
        this.$set(this.treeProps, this.editIndex, this.tempNavProp);
        //this.treeProps[this.editIndex]=this.tempNavProp;
      }
      //this.treeProps.push(this.tempNavProp);
      this.resetTempNavProp();
      this.addNavPropDialogVisible = false;
    },
    cancelUpdateNavProp: function cancelUpdateNavProp() {
      this.resetTempNavProp();
      this.addNavPropDialogVisible = false;
    },
    resetTempNavProp: function resetTempNavProp() {
      this.editIndex = -1;
      this.tempNavProp = {
        label: null,
        iri: null,
        inv: false
      };
    }
  }
});

/***/ }),

/***/ "WUwu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "XgpL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/*
  Because NavViews may need to issue their own ontology queries, we should
  assume that they have access to the Vuex store. Hopefully we can limit store
  interaction to this base component.
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NavView',
  props: ['node', 'property'],
  data: function data() {
    return {
      initSettings: {},
      settingsView: null
    };
  },

  watch: {
    node: function node(val) {
      // node change, may need to send inactive event to parent
      this.notifyActive();
    },
    property: function property(val) {
      // property change, may need to send inactive event to parent
      this.notifyActive();
    }
  },
  computed: {
    navViewSettings: function navViewSettings() {
      return this.$store.getters['getNavViewSettings'];
    },

    settings: {
      get: function get() {
        return this.navViewSettings[this.$options.name];
      },
      set: function set(value) {
        var settingsReg = {
          name: this.$options.name,
          settings: value
        };
        this.$store.commit('addNavViewSettings', settingsReg);
      }
    }
  },
  created: function created() {
    // if this view has settings, register it in the store
    this.settingsRegister();
  },
  mounted: function mounted() {
    /*
      Test upon mounted if this DataView has results to show, notify parent
      if not.
      */
    this.notifyActive();
  },
  methods: {
    notifyActive: function notifyActive() {
      // noop in base DataView
      // emit 'active' if this view has nothing to show
    },
    notifyNodeSelect: function notifyNodeSelect(item) {
      this.$emit('node-selected', item);
    },
    notifyPropertySelect: function notifyPropertySelect(item) {
      this.$emit('property-selected', item);
    },

    // methods to wrap store
    //(so DataView implementations don't need to reference it)
    queryOntology: function queryOntology(sparql) {
      var queryObj = {
        query: sparql
      };

      return this.$store.dispatch('query', queryObj);
    },
    getQueries: function getQueries() {
      return this.$store.getters.getQueries;
    },

    getSettingsView: function getSettingsView() {
      return this.settingsView;
    },

    settingsRegister: function settingsRegister() {
      if (_.isEmpty(this.settings) && !_.isEmpty(this.initSettings)) {
        this.settings = this.initSettings;
      }
    },
    reinit: function reinit() {
      if (!_.isEmpty(this.initSettings)) {
        this.settings = this.initSettings;
      }
    }
  }
});

/***/ }),

/***/ "XreW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settingsView_vue__ = __webpack_require__("z8wg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148ae3ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settingsView_vue__ = __webpack_require__("3jhB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settingsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148ae3ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settingsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YPt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navViews_navView_vue__ = __webpack_require__("GXiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navViews_bidiTree__ = __webpack_require__("fk9h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_settingsViews_bidiTreeSettingsView__ = __webpack_require__("q+cR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['node'],
  components: {
    biditree: __WEBPACK_IMPORTED_MODULE_2__components_navViews_bidiTree__["default"]
  },
  name: 'BidiCarouselTree',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_navViews_navView_vue__["default"],
  data: function data() {
    return {
      settingsDialogVisible: false,

      selectedSlideIndex: 0,
      initSettings: {
        treeProps: _.cloneDeep(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].navProperties),
        isCardStyle: false
      },
      settingsView: __WEBPACK_IMPORTED_MODULE_3__components_settingsViews_bidiTreeSettingsView__["a" /* default */]
    };
  },

  watch: {
    properties: {
      handler: function handler(newVal) {
        this.assignKeys();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.assignKeys();
  },
  computed: {
    subject: function subject() {
      if (this.node == undefined) {
        return null;
      }
      return { data: { iri: this.node.iri }, label: this.node.label };
    },
    getStyle: function getStyle() {
      var style = this.settings.isCardStyle ? 'card' : '';
      return style;
    },
    properties: function properties() {
      if (this.settings == undefined) {
        return [];
      }
      return this.settings.treeProps;
    }
  },
  methods: {
    treeNodeSelected: function treeNodeSelected(nodeinfo) {
      this.$emit('node-selected', nodeinfo);
      //this.refresh(item);
    },
    assignKey: function assignKey(propIndex) {
      var prop = this.properties[propIndex];
      prop.key = prop.label + '_' + Date.now();
    },
    assignKeys: function assignKeys() {
      this.properties.forEach(function (prop) {
        prop.key = prop.label + '_' + Date.now();
      });
    },
    changeActive: function changeActive(index) {
      this.selectedSlideIndex = index;
      //alert("new active slide index = "+index);
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Browser__ = __webpack_require__("mfVH");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Default',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Browser__["a" /* default */]
  }, {
    path: '/browser',
    name: 'Browser',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Browser__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Yf1y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZIff":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZiWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("sgqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_query__ = __webpack_require__("Omah");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

//Separate Module States


//import {app} from './modules/app'
//import {query} from './modules/query';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    'query': __WEBPACK_IMPORTED_MODULE_4__modules_query__["a" /* default */],
    'app': __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */]
  }
}));

/***/ }),

/***/ "a/Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"Search Results","visible":_vm.visible},on:{"close":_vm.close}},[_c('el-table',{attrs:{"data":_vm.results,"stripe":"","height":"300"},on:{"row-click":_vm.resultSelected}},_vm._l((_vm.fields),function(item,index){return _c('el-table-column',{key:index,attrs:{"property":item,"label":item,"sortable":""}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aI1/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f0ln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-checkbox',{model:{value:(_vm.showAxiomAnnots),callback:function ($$v) {_vm.showAxiomAnnots=$$v},expression:"showAxiomAnnots"}},[_vm._v("Include Axiom Annotations")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fk9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiTree_vue__ = __webpack_require__("RJgE");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc946ed6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiTree_vue__ = __webpack_require__("mHz4");
function injectStyle (ssrContext) {
  __webpack_require__("IVpW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc946ed6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gagE":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bidiCarouselCardTree.vue": "5b80",
	"./bidiCarouselTree.vue": "q21A",
	"./bidiMultiTree.vue": "R+qH",
	"./bidiTree.vue": "fk9h",
	"./navView.vue": "GXiQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gagE";

/***/ }),

/***/ "jL/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_settingsViews_settingsView_vue__ = __webpack_require__("XreW");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DescriptionSettingsView",
  extends: __WEBPACK_IMPORTED_MODULE_0__components_settingsViews_settingsView_vue__["a" /* default */],
  data: function data() {
    return {};
  },

  computed: {
    showAxiomAnnots: {
      get: function get() {
        return this.settings['showAxiomAnnots'];
      },
      set: function set(val) {
        this.settings['showAxiomAnnots'] = val;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "klBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataView_vue__ = __webpack_require__("ozD1");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399d965d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataView_vue__ = __webpack_require__("nidi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399d965d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mHz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"tree-container"}},[_c('div',{staticClass:"ancestors"},[_c('ul',{staticClass:"ancestor-content"},_vm._l((_vm.upNodesAsList),function(item){return (_vm.isVisible(item,'up'))?_c('li',{class:_vm.nodeInfo(item,'up').style,style:({ marginLeft: item.level*20 + 'px' }),attrs:{"id":_vm.nodeID(item)}},[_c('i',{staticClass:"treenode clickable",class:_vm.nodeInfo(item,'up').icon,on:{"click":function($event){$event.stopPropagation();return _vm.treeIconClicked(item)}}}),_vm._v(" "),_c('span',{staticClass:"clickable",class:_vm.nodeInfo(item,'up').style,on:{"click":function($event){$event.stopPropagation();return _vm.nodeSelected(item)}}},[_vm._v(_vm._s(item.label))])]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"subject"},[(_vm.displaySubject)?_c('span',[_vm._v(_vm._s(_vm.subjectNode.label))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"descendants"},[_c('ul',{staticClass:"descendant-content"},_vm._l((_vm.downNodesAsList),function(item){return (_vm.isVisible(item,'down'))?_c('li',{class:_vm.nodeInfo(item,'down').style,style:({ marginLeft: item.level*20 + 'px' }),attrs:{"id":_vm.nodeID(item)}},[_c('i',{staticClass:"treenode clickable",class:_vm.nodeInfo(item,'down').icon,on:{"click":function($event){$event.stopPropagation();return _vm.treeIconClicked(item)}}}),_vm._v(" "),_c('span',{staticClass:"clickable",class:_vm.nodeInfo(item,'down').style,on:{"click":function($event){$event.stopPropagation();return _vm.nodeSelected(item)}}},[_vm._v(_vm._s(item.label))])]):_vm._e()}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mfVH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browser_vue__ = __webpack_require__("Hfn6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d183f1a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browser_vue__ = __webpack_require__("va1M");
function injectStyle (ssrContext) {
  __webpack_require__("ZIff")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d183f1a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mjtd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['visible', 'fields', 'results'],
  data: function data() {
    return {};
  },

  /*
  computed: {
    isVisible: function(){
      return this.visible;
    },
    isVisible: {
      get() {
        return this.$store.getters['personal/getContact'];
      },
      set(value) {
        this.$store.commit('personal/setContact', value)
      }
    }
  },
  */
  methods: {
    resultSelected: function resultSelected(event) {
      var node = { label: event.label, iri: event.subject };
      this.$emit('node-selected', node);
      this.$emit('search-close');
      //TODO: 'event' above does not include iri
      //alert(JSON.stringify(event));
    },
    close: function close(event) {
      this.$emit('search-close');
    }
    /*
    watch: {
      visible: function (val) {
        this.visible = val;
      }
    }
    */
  } });

/***/ }),

/***/ "nidi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ohIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navViews_navView_vue__ = __webpack_require__("GXiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navViews_bidiTree__ = __webpack_require__("fk9h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['node'],
  components: {
    biditree: __WEBPACK_IMPORTED_MODULE_2__components_navViews_bidiTree__["default"]
  },
  name: 'BidiMultiTree',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_navViews_navView_vue__["default"],
  data: function data() {
    return {
      treeProps: _.cloneDeep(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].navProperties)
    };
  },

  created: function created() {
    // only up to 4 properties supported
    if (this.treeProps.length > 4) {
      this.treeProps.length = 4;
    }
  },
  computed: {
    treeColWidth: function treeColWidth() {
      return Math.floor(24 / this.treeProps.length);
    },
    subject: function subject() {
      if (this.node == undefined) {
        return null;
      }
      return { data: { iri: this.node.iri }, label: this.node.label };
    }
  },
  methods: {
    treeNodeSelected: function treeNodeSelected(nodeinfo) {
      this.$emit('node-selected', nodeinfo);
      //this.refresh(item);
    }
  }
});

/***/ }),

/***/ "ozD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/*
  Because DataViews may need to issue their own ontology queries, we should
  assume that they have access to the Vuex store. Hopefully we can limit store
  interaction to this base component.
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DataView',
  props: ['node', 'property'],
  data: function data() {
    return {
      //settings:{},//this.$store.getters.getDataViewSettings,
      initSettings: {},
      settingsView: null
    };
  },

  computed: {
    dataViewSettings: function dataViewSettings() {
      return this.$store.getters['getDataViewSettings'];
    },

    settings: {
      get: function get() {
        return this.dataViewSettings[this.$options.name];
      },
      set: function set(value) {
        var settingsReg = {
          name: this.$options.name,
          settings: value
        };
        this.$store.commit('addDataViewSettings', settingsReg);
      }
    }
  },
  watch: {
    node: function node(val) {
      // node change, may need to send inactive event to parent
      this.notifyActive();
    },
    property: function property(val) {
      // property change, may need to send inactive event to parent
      this.notifyActive();
    }
  },
  created: function created() {
    // if this view has settings, register it in the store
    this.settingsRegister();
  },
  mounted: function mounted() {

    var vm = this;
    /*
    this.$store.watch(vm.$store.getters.getSettings, n => {
      console.log('watched: ', n)
    });
     /*
    vm.$store.watch(
      function (state) {
        return state;
      },
      function(){
        //vm.settings = vm.$store.getters['getDataViewSettings'](vm.$options.name);
        console.log("reset to "+JSON.stringify("store settings changed!"));
          //alert("new settings: "+JSON.stringify(vm.$store.getters.getSettings));
      },
      {
        deep: true,
        //immediate: true,
      }
    );
    */
    /*
      Test upon mounted if this DataView has results to show, notify parent
      if not.
      */
    this.notifyActive();

    //test
    //this.settings = initSettings;
  },

  methods: {
    notifyActive: function notifyActive() {
      // noop in base DataView
      // emit 'active' if this view has nothing to show
    },
    notifyNodeSelect: function notifyNodeSelect(item) {
      this.$emit('node-selected', item);
    },
    notifyPropertySelect: function notifyPropertySelect(item) {
      this.$emit('property-selected', item);
    },
    /*
    getSettings: function(){
      return this.settings;
    },
    setSettings: function(settings){
      this.settings = settings;
    },
     getCurrentSettings: function(){
      return this.settings;//this.currentSettings;
    },
    */
    getSettingsView: function getSettingsView() {
      return this.settingsView;
    },

    // methods to wrap store
    //(so DataView implementations don't need to reference it)
    queryOntology: function queryOntology(sparql) {
      var queryObj = {
        query: sparql
      };

      return this.$store.dispatch('query', queryObj);
    },
    getQueries: function getQueries() {
      return this.$store.getters.getQueries;
    },
    /*
    updateSettings: function(newSettings){
      this.settings = newSettings;
      alert("Description view settings changed to "+JSON.stringify(this.settings));
    },
    */

    settingsRegister: function settingsRegister() {
      if (!_.isEmpty(this.initSettings)) {
        this.settings = this.initSettings;
      }
    }
    /*
    settingsUnregister: function(){
     }
    */
  }
});

/***/ }),

/***/ "ptOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"carouseltree-container"}},[_c('el-row',{staticClass:"full-height"},[_c('el-carousel',{attrs:{"trigger":"click","autoplay":false,"height":"100%","type":"card","initial-index":_vm.selectedSlideIndex},on:{"change":_vm.changeActive}},_vm._l((_vm.properties),function(property,index){return _c('el-carousel-item',{key:property.key,staticClass:"tree-col",attrs:{"label":property.label}},[_c('div',{staticClass:"tree-area"},[(_vm.node!=undefined)?_c('biditree',{attrs:{"subject":_vm.subject,"property":property,"displaySubject":index===_vm.selectedSlideIndex},on:{"node-selected":_vm.treeNodeSelected}}):_vm._e()],1)])}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q+cR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiTreeSettingsView_vue__ = __webpack_require__("Uh1d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a252be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiTreeSettingsView_vue__ = __webpack_require__("3oT0");
function injectStyle (ssrContext) {
  __webpack_require__("aI1/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiTreeSettingsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a252be6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiTreeSettingsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q21A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiCarouselTree_vue__ = __webpack_require__("YPt+");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c01918c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiCarouselTree_vue__ = __webpack_require__("AHpp");
function injectStyle (ssrContext) {
  __webpack_require__("zH5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bidiCarouselTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c01918c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bidiCarouselTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rGej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['visible'],
  data: function data() {
    return {
      tempActiveNavView: null,
      tempActiveDataViews: []
    };
  },

  created: function created() {
    this.tempActiveNavView = this.$store.getters.getActiveNavView;
    this.tempActiveDataViews = this.$store.getters.getActiveDataViews;
  },
  computed: {
    /*
    activeNavView:{
      get: function(){
        return this.$store.getters.getActiveNavView;
      },
      set: function(newValue){
        this.tempActiveNavView = newValue;
        //this.$store.commit('setActiveNavView',newValue);
      }
    },
    activeDataViews:{
      get: function(){
        return this.$store.getters.getActiveDataViews;
      },
      set: function(newValue){
        this.tempActiveDataViews = newValue;
        //this.$store.commit('setActiveNavView',newValue);
      }
    }
    */
  },
  methods: {
    clearStoredSettings: function clearStoredSettings(event) {
      this.$store.dispatch('clearStoredSettings');
    },
    persist: function persist(event) {
      //TODO: you are here, add store method to persist settings to local storage, also need code to load these in on start-up
    },
    update: function update(event) {
      this.$store.commit('setActiveNavView', this.tempActiveNavView);
      this.$store.commit('setActiveDataViews', this.tempActiveDataViews);

      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$refs).forEach(function (key, index) {
        // key: the name of the object key
        // index: the ordinal position of the key within the object

        // check if array (TODO:figure out why this is needed)
        var settingsView = vm.$refs[key];
        if (settingsView == undefined) {
          return;
        }
        if (Array.isArray(settingsView)) {
          if (settingsView.length > 0) {
            settingsView[0].saveSettings();
          }
        } else {
          settingsView.saveSettings();
        }
      });

      vm.$store.dispatch('storeSettings');

      //this.$emit('settings-update');
      this.$emit('settings-close');
    },
    close: function close(event) {
      this.$emit('settings-close');
    }

  }
});

/***/ }),

/***/ "s5U/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dataViews_dataView_vue__ = __webpack_require__("klBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_settingsViews_descriptionSettingsView__ = __webpack_require__("s8wg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Description",
  extends: __WEBPACK_IMPORTED_MODULE_1__components_dataViews_dataView_vue__["default"],
  data: function data() {
    return {
      nodeData: [],
      config: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */],
      initSettings: { showAxiomAnnots: true },
      settingsView: __WEBPACK_IMPORTED_MODULE_2__components_settingsViews_descriptionSettingsView__["a" /* default */]
    };
  },

  computed: {
    /*
    showAxiomAnnots:{
      get:function(){
        return this.settings.views.dataViews['Descriptiong'].show; // could dynamically retrieve name
      }
    }
    */
  },
  watch: {
    node: function node(val) {
      this.treeNodeSelected(val);
    }
  },
  mounted: function mounted() {
    if (this.node != undefined) {
      this.treeNodeSelected(this.node);
    }
  },
  methods: {
    treeNodeSelectedInternal: function treeNodeSelectedInternal(node) {
      //this.$emit('node-selected',{iri:node.iri,label:node.label});
      this.notifyNodeSelect({ iri: node.iri, label: node.label });
      this.treeNodeSelected(node);
    },
    treeNodeSelected: function treeNodeSelected(node) {
      var _this = this;

      var queryString = this.getQueries().all_properties_query(node.iri);
      //var queryInfo = {query: queryString};
      var promise = this.queryOntology(queryString);
      promise.then(function (results) {
        _this.updateNodeData(results);
      }).catch(function (errors) {
        _this.handleErrors(errors.statusText);
      });
    },
    updateNodeData: function updateNodeData(results) {
      //this.raw=results;
      // property, value, label
      var resObj = results; //JSON.parse(results);
      var comp = function comp(a, b) {
        return a.property.value === b.property.value && a.value.value === b.value.value;
      };
      var uniqueResults = _.uniqWith(resObj.results.bindings, comp);
      /*
      if(resObj.results.bindings.length>0){
        var uniqueResults = _.uniqWith(resObj.results.bindings, comp);
        //alert(uniqueResults);
      }
      */
      var bindings = uniqueResults; //resObj.results.bindings;
      var propVals = [];

      // test
      var lastProp = null;
      var currValArray = null;
      for (var count = 0; count < bindings.length; count++) {
        var binding = bindings[count];
        var currProp = /[^/]*$/.exec(binding.property.value)[0]; //binding.property.value;

        if (lastProp === null || currProp !== lastProp) {
          // new property found
          lastProp = currProp;
          currValArray = [];
          propVals.push({
            property: lastProp,
            values: currValArray
          });
        }
        var val = {};

        val['value'] = binding.value.value;

        if (typeof binding.label !== "undefined") {
          val['label'] = binding.label.value;
        }

        // get axiom annotations
        var annotations = [];
        var axiomOccurences = resObj.results.bindings.filter(function (currAxBinding) {
          return currAxBinding.property.value === binding.property.value && currAxBinding.value.value === binding.value.value;
        });
        axiomOccurences.forEach(function (element) {
          // skip annotations that are not completely defined
          if (typeof element.annotProperty == "undefined" || typeof element.annotValue == "undefined") {
            return;
          }
          var currAnnot = {};
          var currAnnotProp = /[^/]*$/.exec(element.annotProperty.value)[0];
          currAnnot['annotationProperty'] = currAnnotProp;
          currAnnot['annotationValue'] = element.annotValue;
          annotations.push(currAnnot);
        });

        if (annotations.length > 0) {
          val['annotations'] = annotations;
        }

        currValArray.push(val);
      }
      this.nodeData = propVals;
    },

    /*
    getAxiomAnnotations: function(subject, property, object){
      var queryString = this.getQueries().axiom_annotations_query(subject,property,object);
      //var queryInfo = {query: queryString};
      var promise = this.queryOntology(queryString);
      promise.then((results) => {
    	this.updateNodeData(results);
    }).catch((errors) => {
    	this.handleErrors(errors.statusText);
    });
    }
    */
    handleErrors: function handleErrors(errors) {
      alert("description errors: " + errors);
    }
  }
});

/***/ }),

/***/ "s8wg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_descriptionSettingsView_vue__ = __webpack_require__("jL/f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3531da04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_descriptionSettingsView_vue__ = __webpack_require__("f0ln");
function injectStyle (ssrContext) {
  __webpack_require__("C9qN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_descriptionSettingsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3531da04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_descriptionSettingsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sgqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




var state = {
  //config:config,
  settings: {
    fromLocalStorage: false,
    general: {
      navProperties: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].navProperties, // TODO: centralize nav properties (e.g. not per nav view)
      activeDataViews: [],
      activeNavView: null
    },
    views: {
      dataViews: {},
      navViews: {}
    }
  },
  /*
  settingsViewMap: {
    dataViews:{},
    navViews:{},
  },
  */
  /*
  settingsReg:{
    DataViews:{},
    NavViews:{},
  },
  */

  node: null,
  property: null,
  history: [],
  historyIndex: -1,
  runningQueries: [],

  allDataViews: [],
  //selectedDataViews:[],
  allNavViews: []
  //selectedNavViews:[],
};

var getters = {
  /*
  getConfig(state) {
    return state.config;
  },
  */
  getSettings: function getSettings(state) {
    return state.settings;
  },
  getDataViewSettings: function getDataViewSettings(state) {
    //return viewName => state.settings.views.dataViews[viewName];
    return state.settings.views.dataViews;
  },
  getNavViewSettings: function getNavViewSettings(state) {
    return state.settings.views.navViews;
  },
  getActiveDataViews: function getActiveDataViews(state) {
    return state.settings.general.activeDataViews;
  },
  getActiveNavView: function getActiveNavView(state) {
    return state.settings.general.activeNavView;
  },
  settingsFromLocalStorage: function settingsFromLocalStorage(state) {
    return state.settings.fromLocalStorage;
  },

  //getDataViewSettings: state => viewName => state.settings.views.dataViews[viewName],
  /*
  getDataViewSettings(state) {
    return state.settings.views.dataViews[viewName];
  },
  getNavViewSettings(state,navViewName){
    return state.settings.views.navViews[navViewName];
  },
  */
  /*
  getSettingsViewMap(state){
    return settingsViewMap;
  },
  */
  getNode: function getNode(state) {
    return state.node;
  },
  getProperty: function getProperty(state) {
    return state.property;
  },
  getHasHistoryForward: function getHasHistoryForward(state) {
    return state.history.length > state.historyIndex + 1 ? true : false;
  },
  getHasHistoryBackward: function getHasHistoryBackward(state) {
    return state.historyIndex > 0 ? true : false;
  },
  getNextNodeForwardLabel: function getNextNodeForwardLabel(state) {
    var nextForwardNode = state.history[state.historyIndex + 1];
    if (nextForwardNode !== undefined) {
      return nextForwardNode.label;
    } else {
      return '';
    }
  },
  getNextNodeBackwardLabel: function getNextNodeBackwardLabel(state) {
    var nextBackwardNode = state.history[state.historyIndex - 1];
    if (nextBackwardNode !== undefined) {
      return nextBackwardNode.label;
    } else {
      return '';
    }
  },
  getAllDataViews: function getAllDataViews(state) {
    return state.allDataViews;
  },
  getAllNavViews: function getAllNavViews(state) {
    return state.allNavViews;
  },
  getLoading: function getLoading(state) {
    if (state.runningQueries && state.runningQueries.length) {
      return true;
    }
    return false;
  }

  /*
  getSelectedDataViews(state){
    return state.settings.general.selectedDataViews;
  },
  getSelectedNavViews(state){
    return state.settings.general.selectedNavViews;
  }
  */

};

var mutations = {
  setNode: function setNode(state, node) {
    state.node = node;
  },
  setProperty: function setProperty(state, property) {
    state.property = property;
  },
  setAllDataViews: function setAllDataViews(state, views) {
    state.allDataViews = views;
  },
  setAllNavViews: function setAllNavViews(state, views) {
    state.allNavViews = views;
  },

  /*
  setSettings(state,settings){
    state.settings = settings;
  },
  */
  setActiveDataViews: function setActiveDataViews(state, views) {
    state.settings.general.activeDataViews = views;
  },
  setActiveNavView: function setActiveNavView(state, view) {
    state.settings.general.activeNavView = view;
  },
  addDataViewSettings: function addDataViewSettings(state, settingsEntry) {
    var name = settingsEntry.name;
    var settings = _.cloneDeep(settingsEntry.settings);
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.settings.views.dataViews, name, settings);
    //state.settings.views.dataViews[name]=settings;
  },
  addNavViewSettings: function addNavViewSettings(state, settingsEntry) {
    var name = settingsEntry.name;
    var settings = _.cloneDeep(settingsEntry.settings);
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.settings.views.navViews, name, settings);
    //state.settings.views.navViews[name]=settings;
  },
  initializeSettings: function initializeSettings(state) {
    // Check if the ID exists
    if (localStorage.getItem('settings')) {
      state.settings = JSON.parse(localStorage.getItem('settings'));
      state.settings.fromLocalStorage = true;
      //console.log("settings =  "+JSON.stringify(state.settings));
    }
  },
  setQueryStarted: function setQueryStarted(state, queryID) {
    state.runningQueries.push(queryID);
  },
  setQueryFinished: function setQueryFinished(state, queryID) {
    _.pull(state.runningQueries, queryID);
  }
};

var actions = {
  /*
  setNodeByIRI(context,iri){
    context.dispatch('query')
  },
  */
  setNodeWithHistory: function setNodeWithHistory(context, node) {
    context.state.node = node;
    //add to history (clear all previous history after this node)
    context.state.historyIndex++;
    context.state.history.length = context.state.historyIndex;
    context.state.history.push(node);
  },

  historyForward: function historyForward(context) {
    context.state.historyIndex++;
    var toNode = context.state.history[context.state.historyIndex];
    context.state.node = toNode;
  },
  historyBackward: function historyBackward(context) {
    context.state.historyIndex--;
    var toNode = context.state.history[context.state.historyIndex];
    context.state.node = toNode;
  },
  storeSettings: function storeSettings(context) {
    localStorage.setItem('settings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.state.settings));
  },
  clearStoredSettings: function clearStoredSettings(context) {
    // clear local storage
    localStorage.removeItem('settings');

    // tell all views to load init settings
    var activeNavView = context.state.settings.general.activeNavView;
    //activeNavView.reinit();
    //TODO: finish/redo the above logic of resetting settings to default

    //temp solution
    window.location.reload(true);
  }

  /*
  settingsRegister(context,settingsReg){
    //alert("asdfasd"+JSON.stringify(settingsReg));
    var type = settingsReg.type;
    var name = settingsReg.name;
    var settings = settingsReg.settings;
    if(type==="DataView"){
      context.state.settings.views.dataViews[name]=settings;
    }
    else if(type==="NavView"){
      context.state.settings.views.navViews[name]=settings;
    }
  }
  */
};

var module = {
  namespaced: false,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "va1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container-area"}},[_c('el-row',{staticClass:"full-height"},[_c('el-col',{staticClass:"full-height",attrs:{"id":"nav-col","span":_vm.navWidth}},[(_vm.navView !== null)?_c(_vm.navView.view,{tag:"component",attrs:{"node":_vm.node},on:{"node-selected":_vm.nodeSelected}}):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"id":"content-col","span":_vm.contentWidth}},[(_vm.dataViews.length>0)?_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.selectedDataView),callback:function ($$v) {_vm.selectedDataView=$$v},expression:"selectedDataView"}},_vm._l((_vm.dataViews),function(dataView){return _c('el-tab-pane',{key:dataView.name,attrs:{"label":dataView.name,"name":dataView.name,"disabled":!dataView.isActive}},[_c('div',{attrs:{"id":"tab-content"}},[(_vm.node != undefined)?_c(dataView.view,{tag:"component",attrs:{"node":_vm.node,"property":_vm.$store.getters.getProperty},on:{"active":function($event){dataView.isActive=arguments[0]},"node-selected":_vm.nodeSelected,"property-selected":function($event){}}}):_vm._e()],1)])}),1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_searchResultsDialog__ = __webpack_require__("NJPy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_settingsDialog__ = __webpack_require__("PPU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Browser__ = __webpack_require__("mfVH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("QmSG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OntTK',
  components: {
    browser: __WEBPACK_IMPORTED_MODULE_3__components_Browser__["a" /* default */],
    searchResultsDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_searchResultsDialog__["a" /* default */],
    settingsDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_settingsDialog__["a" /* default */]
  },
  data: function data() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].title,
      bookmarks: [],
      selectedBookmark: null,
      settingsDialogVisible: false,
      currSettings: {},

      // search related fields
      config: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */],
      searchTerm: null,
      searchResultsDialogVisible: false,
      searchResults: [],

      // layout related fields
      navWidth: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].navWidth
      //navWidthMax: 24,
    };
  },

  created: function created() {
    // retrieve stored bookmarks
    var persistentBookmarks = localStorage.getItem('onttk-bookmarks');
    if (persistentBookmarks != undefined) {
      this.bookmarks = JSON.parse(persistentBookmarks);
    }

    // TODO: check local storage
    //this.currSettings = this.$store.getters.getSettings;

    // check and see if there was an IRI specified in the URL
    var iri = this.$route.query.iri;
    if (iri != undefined) {
      this.setNodeByIRI(iri);
    } else {
      this.$store.dispatch('setNodeWithHistory', __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].init.node);
    }
  },
  computed: {
    isLoading: function isLoading() {
      return this.$store.getters.getLoading;
    },
    currNode: function currNode() {
      return this.$store.getters.getNode;
    },
    isBookmarked: function isBookmarked() {
      if (this.currNode == undefined) return false;

      var currIRI = this.currNode.iri;
      var match = this.bookmarks.filter(function (bookmark) {
        return bookmark.iri === currIRI;
      });
      return match.length > 0;
    }
  },
  methods: {
    showSettings: function showSettings() {
      this.settingsDialogVisible = true;
    },
    bookmarkAdd: function bookmarkAdd() {
      var node = this.currNode;
      this.bookmarks.push(node);
      localStorage.setItem('onttk-bookmarks', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bookmarks));
      //alert('bookmarking '+node.label);
    },
    bookmarkRemove: function bookmarkRemove() {
      var node = this.currNode;
      this.bookmarks = this.bookmarks.filter(function (item) {
        return item.iri !== node.iri;
      });
      localStorage.setItem('onttk-bookmarks', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bookmarks));
      //alert('deleting bookmark '+node.label);
    },
    bookmarkRemoveSelected: function bookmarkRemoveSelected(selected) {
      this.bookmarks = this.bookmarks.filter(function (item) {
        return item.iri !== selected.iri;
      });
      localStorage.setItem('onttk-bookmarks', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bookmarks));
    },
    setNodeByIRI: function setNodeByIRI(iri) {
      var _this = this;

      var promise = this.$store.dispatch('query', { query: this.config.iri_search.query(iri) });

      promise.then(function (results) {
        _this.searchResults = [];
        var resObj = results; //JSON.parse(results);
        var bindings = resObj.results.bindings;
        if (bindings.length > 0) {
          var binding = bindings[0];
          var nodeForIRI = { label: binding.label.value, iri: iri };
          //this.$store.commit('setNodeWithHistory',nodeForIRI);
          _this.$store.dispatch('setNodeWithHistory', nodeForIRI);
        } else {
          // TODO: improve error handling
          alert("No class found for IRI: " + iri);
        }
      }).catch(function (errors) {
        // TODO: improve error handling
        alert("failed iri search for " + iri);
      });
    },
    search: function search(event) {
      var _this2 = this;

      var searchTerm = event.target.value;
      searchTerm = searchTerm.trim();
      searchTerm = searchTerm.replace(/[\/\(\)\{\}\+\_\&\|\!\{\}\^\"\~\:\\]/g, "?");
      searchTerm = searchTerm.replace(/ /g, '\\\\ ');
      console.log("searchTerm = " + searchTerm);
      var promise = this.$store.dispatch('query', { query: this.config.search.query(searchTerm) });
      promise.then(function (results) {
        _this2.searchResults = [];
        var resObj = results; //JSON.parse(results);
        var bindings = resObj.results.bindings;
        var searchResults = [];
        for (var count = 0; count < bindings.length; count++) {
          var binding = bindings[count];
          var searchResult = {};
          for (var bindingVar in binding) {
            searchResult[bindingVar] = binding[bindingVar].value;
          }
          _this2.searchResults.push(searchResult);
        }
        _this2.searchResultsDialogVisible = true;
      }).catch(function (errors) {
        console.log("failed search for " + searchTerm);
      });
    },
    setSelectedNode: function setSelectedNode(node) {
      //this.$store.commit('setNode',node);
      this.$store.dispatch('setNodeWithHistory', node);
    },
    settingsUpdate: function settingsUpdate() {
      this.settingsDialogVisible = false;
    }
  }
});

/***/ }),

/***/ "z8wg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/*
  SettingsViews need access to the Vuex store. Hopefully we can limit store
  interaction to this base component.
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SettingsView',
  props: ['view'],
  data: function data() {
    return {
      internalSettings: {}
    };
  },

  computed: {
    dataViewSettings: function dataViewSettings() {
      return this.$store.getters['getDataViewSettings'];
    },
    navViewSettings: function navViewSettings() {
      return this.$store.getters['getNavViewSettings'];
    },
    settings: {
      get: function get() {
        return this.internalSettings;
      },
      set: function set(val) {
        this.internalSettings = val;
      }
    }

  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // initialize settings
    var type = this.view.view.extends.name;
    var viewName = this.view.view.name;
    if (type === 'DataView') {
      this.settings = _.cloneDeep(this.dataViewSettings[viewName]);
    } else if (type === 'NavView') {
      this.settings = _.cloneDeep(this.navViewSettings[viewName]);
    }
  },
  methods: {
    saveSettings: function saveSettings() {
      var type = this.view.view.extends.name;
      var settingsReg = {
        name: this.view.view.name,
        settings: this.internalSettings
      };
      if (type === 'DataView') {
        this.$store.commit('addDataViewSettings', settingsReg);
      } else if (type === 'NavView') {
        this.$store.commit('addNavViewSettings', settingsReg);
      }
    }
  }
});

/***/ }),

/***/ "zH5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7c750f3e9e732f14989f.js